module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1013-90d35ab2253a162a0fbee746553bbf5e.png";